import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 崩溃日志列表
export const setCrashes: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 组织列表
export const setCrashOrgs: Mutation<IModuleState> = (state, payload) => {
  state.orgs.data = payload.data;
  state.orgs.loading = !!payload.loading;
};

// 用户列表
export const setCrashUsers: Mutation<IModuleState> = (state, payload) => {
  state.users.data = payload.data;
  state.users.loading = !!payload.loading;
};

// 列表的搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
